<template>
  <ContentLayout>
    <template #header>
      <h4>Links</h4>
    </template>
    
    <div v-if="links" class="links">
      <div class="links--item">
        <div v-for="(link, key) in links" :key="key">
          <a v-if="link[0] === 'E'" :href="link[2]" target="_blank" class="links--item-link">{{ link[1] }}</a>
        </div>
      </div>
      <div class="links--item">
        <div v-for="(link, key) in links" :key="key">
          <a v-if="link[0] === 'D'" :href="link[2]" target="_blank" class="links--item-link secondary">{{ link[1] }}</a>
        </div>
      </div>
    </div>
  </ContentLayout>
</template>

<script>
import axios from 'axios';
import ContentLayout from '../components/ContentLayout';

export default {
  components: {
    ContentLayout
  },
  data: () => ({
    links: null
  }),
  methods: {
    async getLinks() {
      const response = await axios.get('./links.json');
      this.links = response.data;
    }
  },
  mounted() {
    this.getLinks();
  }
};
</script>

<style lang="scss" scoped>
.links {
  display: flex;
  justify-content: space-between;

  .links--item {
    width: 49.5%;

    .links--item-link {
      display: block;
      background: #FFFFCC;
      text-align: center;
      color: var(--color-black);
      border: 1px solid var(--color-mid-blue);
      padding: 10px 15px;
      margin: 4px 0;
      cursor: pointer;

      &:visited {
        color: var(--color-black);
      }
      
      &.secondary {
        background: #99CCFF;
      }
    }
  }
}

@media (max-width: 900px) {
  .links {
    .links--item {
      .links--item-link {
        height: 52px;
      }
    }
  }
}

</style>
